import { createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7c7a0375")

_pushScopeId("data-v-7c7a0375")
const _hoisted_1 = { class: "card border-left-warning shadow mx-0 mb-4 animated fadeIn" }
const _hoisted_2 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, " User Details ", -1)
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = { class: "mb-5 mt-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fas fa-building" }, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-lg-4 col-md-4 col-sm-6 col-6" }, null, -1)
const _hoisted_10 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Email")
], -1)
const _hoisted_12 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_13 = {
  key: 0,
  title: "Email confirmed",
  class: "text-success"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_15 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
  })
], -1)
const _hoisted_17 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "Created At", -1)
const _hoisted_19 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_20 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "Address Line:", -1)
const _hoisted_22 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_23 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, "MSB:", -1)
const _hoisted_25 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_26 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", null, "Nature:", -1)
const _hoisted_28 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_29 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", null, "Entity Name:", -1)
const _hoisted_31 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_32 = { class: "col-lg-4 col-md-4 col-sm-6 col-6" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", null, "Entity Type:", -1)
const _hoisted_34 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_35 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_36 = /*#__PURE__*/_createVNode("label", null, "Website:", -1)
const _hoisted_37 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_38 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", null, "Is Mines Bitcoin:", -1)
const _hoisted_40 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_41 = { class: "col-lg-4 col-md-4 col-sm-12 col-xs-12" }
const _hoisted_42 = /*#__PURE__*/_createVNode("label", null, "Wallet Address:", -1)
const _hoisted_43 = { class: "card-subtitle mb-2 text-muted" }
const _hoisted_44 = { class: "row mt-3" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { class: "d-flex justify-content-between" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", null, "Files", -1)
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" See Full History ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" No Files. ")
const _hoisted_50 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_51 = { class: "row mt-5" }
const _hoisted_52 = { class: "col-12" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-12" }
const _hoisted_55 = /*#__PURE__*/_createVNode("b", null, "Email:", -1)
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = /*#__PURE__*/_createVNode("b", null, "Related with government:", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_60 = { class: "col-6 text-center" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Identification ")
const _hoisted_62 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_63 = { class: "col-6 text-center" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Identification Back ")
const _hoisted_65 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createVNode("span", null, "Authorized Signers")
], -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" No Authorized Signers. ")
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_70 = { class: "row mt-5" }
const _hoisted_71 = { class: "col-12" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = /*#__PURE__*/_createVNode("b", null, "Email:", -1)
const _hoisted_75 = { class: "col-12" }
const _hoisted_76 = /*#__PURE__*/_createVNode("b", null, "Accredited:", -1)
const _hoisted_77 = { class: "col-12" }
const _hoisted_78 = /*#__PURE__*/_createVNode("b", null, "Phone Number:", -1)
const _hoisted_79 = { class: "col-12" }
const _hoisted_80 = /*#__PURE__*/_createVNode("b", null, "Related with government:", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_83 = { class: "col-6 text-center" }
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" Identification ")
const _hoisted_85 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_86 = { class: "col-6 text-center" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" Identification Back ")
const _hoisted_88 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { class: "col-12 text-center" }
const _hoisted_91 = /*#__PURE__*/_createVNode("h6", null, "Percentage of equity", -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createVNode("span", null, "Beneficial Owners")
], -1)
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" No Beneficial Owners. ")
const _hoisted_94 = /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_95 = { class: "row mt-5" }
const _hoisted_96 = { class: "col-12" }
const _hoisted_97 = /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createVNode("span", null, "Admin Updates")
], -1)
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" No Updates. ")
const _hoisted_99 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_100 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_101 = { class: "row mt-4" }
const _hoisted_102 = { class: "col-4" }
const _hoisted_103 = /*#__PURE__*/_createVNode("b", null, [
  /*#__PURE__*/_createVNode("label", null, "Approve Account?")
], -1)
const _hoisted_104 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_105 = { class: "form-check form-check-inline" }
const _hoisted_106 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "yes-approve"
}, "Yes", -1)
const _hoisted_107 = { class: "form-check form-check-inline" }
const _hoisted_108 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "no-approve"
}, "No", -1)
const _hoisted_109 = { class: "col-8" }
const _hoisted_110 = {
  key: 0,
  class: "form-group"
}
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" Approve ")
const _hoisted_112 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"
  })
], -1)
const _hoisted_113 = {
  key: 0,
  class: "row"
}
const _hoisted_114 = { class: "col" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Reject ")
const _hoisted_116 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M20 6.91L17.09 4L12 9.09L6.91 4L4 6.91L9.09 12L4 17.09L6.91 20L12 14.91L17.09 20L20 17.09L14.91 12L20 6.91Z"
  })
], -1)
const _hoisted_117 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col" }, [
    /*#__PURE__*/_createVNode("hr")
  ])
], -1)
const _hoisted_118 = { class: "row" }
const _hoisted_119 = /*#__PURE__*/_createVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-weight-bold h6 text-left mb-3" }, [
    /*#__PURE__*/_createTextVNode(" Security Options "),
    /*#__PURE__*/_createVNode("i", { class: "fas fa-shield-alt" })
  ])
], -1)
const _hoisted_120 = { class: "col-12 text-left" }
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" Current Status:    ")
const _hoisted_122 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_123 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_124 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_125 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" Two-Factor Authentication:    ")
const _hoisted_127 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_128 = {
  key: 3,
  class: "badge badge-warning"
}
const _hoisted_129 = /*#__PURE__*/_createVNode("i", { class: "fas fa-undo-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Knob = _resolveComponent("Knob")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        href: "#",
        class: "text-dark mr-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
      }, [
        _hoisted_3
      ]),
      _hoisted_4
    ]),
    (_ctx.selectedUser)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("h4", _hoisted_6, [
            _createVNode("b", null, [
              _createTextVNode(_toDisplayString(_ctx.selectedUser.firstName || '--') + " " + _toDisplayString(_ctx.selectedUser.lastName || '--') + " ", 1),
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("h6", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.selectedUser.email) + " ", 1),
                (_ctx.selectedUser.emailConfirmed)
                  ? (_openBlock(), _createBlock("span", _hoisted_13, [
                      _hoisted_14
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_15, [
                      _hoisted_16
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("b", null, [
                _hoisted_18,
                _createVNode("h6", _hoisted_19, _toDisplayString(_ctx.formatDate(_ctx.selectedUser.createdAt)), 1)
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("b", null, [
                _hoisted_21,
                _createVNode("h6", _hoisted_22, _toDisplayString(_ctx.selectedUser.addressLine1 || '--'), 1)
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("b", null, [
                _hoisted_24,
                _createVNode("h6", _hoisted_25, _toDisplayString(_ctx.selectedUser?.corporate?.MSB ? 'YES' : 'NO'), 1)
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("b", null, [
                _hoisted_27,
                _createVNode("h6", _hoisted_28, _toDisplayString(_ctx.selectedUser?.corporate?.businessNature || '--'), 1)
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("b", null, [
                _hoisted_30,
                _createVNode("h6", _hoisted_31, _toDisplayString(_ctx.selectedUser?.corporate?.entityName || '--'), 1)
              ])
            ]),
            _createVNode("div", _hoisted_32, [
              _createVNode("b", null, [
                _hoisted_33,
                _createVNode("h6", _hoisted_34, _toDisplayString(_ctx.selectedUser?.corporate?.entityType || '--'), 1)
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("b", null, [
                _hoisted_36,
                _createVNode("h6", _hoisted_37, [
                  _createVNode("a", {
                    href: _ctx.selectedUser?.corporate?.website,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(_ctx.selectedUser?.corporate?.website || '--'), 9, ["href"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("b", null, [
                _hoisted_39,
                _createVNode("h6", _hoisted_40, _toDisplayString(_ctx.selectedUser?.corporate?.minesBitcoin ? 'YES' : 'NO'), 1)
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("b", null, [
                _hoisted_42,
                _createVNode("h6", _hoisted_43, _toDisplayString(_ctx.selectedUser?.corporate?.walletAddress || '---'), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_44, [
            _createVNode("div", _hoisted_45, [
              _createVNode(_component_DataTable, {
                value: _ctx.filterFiles,
                autoLayout: true,
                filterDisplay: "menu"
              }, {
                header: _withId(() => [
                  _createVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_router_link, {
                      to: {
                    name: 'dashboard.file.history',
                    params: { id: _ctx.selectedUser?.id }
                  }
                    }, {
                      default: _withId(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                empty: _withId(() => [
                  _hoisted_49
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    header: "Document",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.separeteByCapital(slotProps.data.typeOfDocument)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "uploadedAt",
                    header: "Uploaded At",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Action",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createVNode("button", {
                        class: "btn btn-sm btn-primary",
                        onClick: ($event: any) => (_ctx.downloadDocument(slotProps.data))
                      }, [
                        _hoisted_50
                      ], 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _createVNode(_component_Dialog, {
                draggable: true,
                style: {"max-width":"400px","min-width":"400px"},
                header: _ctx.signerDetails?.name,
                visible: _ctx.signerModal,
                "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.signerModal = $event))
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_53, [
                    _createVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createTextVNode(" " + _toDisplayString(_ctx.signerDetails.email), 1)
                    ]),
                    _createVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createTextVNode(" " + _toDisplayString(_ctx.signerDetails.relatedGovernment ? 'YES' : 'NO'), 1)
                    ]),
                    _hoisted_58,
                    _hoisted_59,
                    _createVNode("div", _hoisted_60, [
                      (_ctx.signerDetails?.identificationFile?.key)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadDocument(_ctx.signerDetails?.identificationFile))),
                            class: "btn btn-primary btn-sm"
                          }, [
                            _hoisted_61,
                            _hoisted_62
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_63, [
                      (_ctx.signerDetails?.identificationBackFile?.key)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.downloadDocument(_ctx.signerDetails?.identificationBackFile)
                  )),
                            class: "btn btn-primary btn-sm"
                          }, [
                            _hoisted_64,
                            _hoisted_65
                          ]))
                        : (_openBlock(), _createBlock("small", _hoisted_66, "File not uploaded"))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header", "visible"]),
              _createVNode(_component_DataTable, {
                value: _ctx.selectedUser?.corporate?.authorizedSigners,
                autoLayout: true,
                filterDisplay: "menu"
              }, {
                header: _withId(() => [
                  _hoisted_67
                ]),
                empty: _withId(() => [
                  _hoisted_68
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "email",
                    header: "Email",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.hideEmail(slotProps.data.email)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "name",
                    header: "Name",
                    bodyStyle: "text-align: left"
                  }),
                  _createVNode(_component_Column, {
                    header: "Related With Governament",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.relatedGovernment ? 'YES' : 'NO'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Details",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createVNode("button", {
                        onClick: ($event: any) => (_ctx.showSignerDatails(slotProps.data)),
                        class: "btn btn-sm btn-info"
                      }, [
                        _hoisted_69
                      ], 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_70, [
            _createVNode("div", _hoisted_71, [
              _createVNode(_component_Dialog, {
                draggable: true,
                style: {"max-width":"400px","min-width":"400px"},
                header: _ctx.beneficialDetails?.name,
                visible: _ctx.beneficialModal,
                "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.beneficialModal = $event))
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_72, [
                    _createVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _createTextVNode(" " + _toDisplayString(_ctx.beneficialDetails.email), 1)
                    ]),
                    _createVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createTextVNode(" " + _toDisplayString(_ctx.beneficialDetails.accredited ? 'YES' : 'NO'), 1)
                    ]),
                    _createVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _createTextVNode(" " + _toDisplayString(_ctx.beneficialDetails.phoneNumber), 1)
                    ]),
                    _createVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createTextVNode(" " + _toDisplayString(_ctx.beneficialDetails.relatedGovernment ? 'YES' : 'NO'), 1)
                    ]),
                    _hoisted_81,
                    _hoisted_82,
                    _createVNode("div", _hoisted_83, [
                      (_ctx.beneficialDetails?.identificationFile?.key)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (
                    _ctx.downloadDocument(_ctx.beneficialDetails?.identificationFile)
                  )),
                            class: "btn btn-primary btn-sm"
                          }, [
                            _hoisted_84,
                            _hoisted_85
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_86, [
                      (_ctx.beneficialDetails?.identificationBackFile?.key)
                        ? (_openBlock(), _createBlock("button", {
                            key: 0,
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (
                    _ctx.downloadDocument(_ctx.beneficialDetails?.identificationBackFile)
                  )),
                            class: "btn btn-primary btn-sm"
                          }, [
                            _hoisted_87,
                            _hoisted_88
                          ]))
                        : (_openBlock(), _createBlock("small", _hoisted_89, "File not uploaded"))
                    ]),
                    _createVNode("div", _hoisted_90, [
                      _createVNode(_component_Knob, {
                        readonly: "",
                        valueTemplate: "{value}%",
                        modelValue: _ctx.beneficialDetails.equity,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.beneficialDetails.equity = $event))
                      }, null, 8, ["modelValue"]),
                      _hoisted_91
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header", "visible"]),
              _createVNode(_component_DataTable, {
                value: _ctx.selectedUser?.corporate?.beneficialOwners,
                autoLayout: true
              }, {
                header: _withId(() => [
                  _hoisted_92
                ]),
                empty: _withId(() => [
                  _hoisted_93
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "email",
                    header: "Email",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.hideEmail(slotProps.data.email)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "name",
                    header: "Name",
                    bodyStyle: "text-align: left"
                  }),
                  _createVNode(_component_Column, {
                    field: "phoneNumber",
                    header: "Phone Number",
                    bodyStyle: "text-align: left"
                  }),
                  _createVNode(_component_Column, {
                    header: "Accredited",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.accredited ? 'YES' : 'NO'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Related With Governament",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.relatedGovernment ? 'YES' : 'NO'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Details",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createVNode("button", {
                        onClick: ($event: any) => (_ctx.showBeneficialDatails(slotProps.data)),
                        class: "btn btn-sm btn-info"
                      }, [
                        _hoisted_94
                      ], 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_95, [
            _createVNode("div", _hoisted_96, [
              _createVNode(_component_DataTable, {
                value: _ctx.adminUpdates,
                responsiveLayout: true
              }, {
                header: _withId(() => [
                  _hoisted_97
                ]),
                empty: _withId(() => [
                  _hoisted_98
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "admin.email",
                    header: "Email"
                  }),
                  _createVNode(_component_Column, { header: "Action" }, {
                    body: _withId((slotProps) => [
                      (slotProps.data.status === 2)
                        ? (_openBlock(), _createBlock("span", _hoisted_99, " Approved "))
                        : _createCommentVNode("", true),
                      (slotProps.data.status === 3)
                        ? (_openBlock(), _createBlock("span", _hoisted_100, " Rejected "))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Date" }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.createdAt)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Details",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.relatedGovernament ? 'YES' : 'NO'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ]),
          _createVNode("div", _hoisted_101, [
            _createVNode("div", _hoisted_102, [
              _hoisted_103,
              _hoisted_104,
              _createVNode("div", _hoisted_105, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.approveAccount = $event)),
                  class: "form-check-input",
                  type: "radio",
                  name: "yes-approve",
                  id: "yes-approve",
                  value: true
                }, null, 512), [
                  [_vModelRadio, _ctx.approveAccount]
                ]),
                _hoisted_106
              ]),
              _createVNode("div", _hoisted_107, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.approveAccount = $event)),
                  class: "form-check-input",
                  type: "radio",
                  name: "no-approve",
                  id: "no-approve",
                  value: false
                }, null, 512), [
                  [_vModelRadio, _ctx.approveAccount]
                ]),
                _hoisted_108
              ])
            ]),
            _createVNode("div", _hoisted_109, [
              (!_ctx.approveAccount)
                ? (_openBlock(), _createBlock("div", _hoisted_110, [
                    _withDirectives(_createVNode("textarea", {
                      placeholder: "Explain why...",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.comments = $event)),
                      class: "form-control",
                      id: "comments",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _ctx.comments]
                    ])
                  ]))
                : (_openBlock(), _createBlock("button", {
                    key: 1,
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.approveUserAccount && _ctx.approveUserAccount(...args))),
                    class: "btn btn-success mt-3"
                  }, [
                    _hoisted_111,
                    _hoisted_112
                  ]))
            ])
          ]),
          (!_ctx.approveAccount)
            ? (_openBlock(), _createBlock("div", _hoisted_113, [
                _createVNode("div", _hoisted_114, [
                  _createVNode("button", {
                    disabled: _ctx.comments.length < 4,
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.approveUserAccount && _ctx.approveUserAccount(...args))),
                    class: "btn btn-danger"
                  }, [
                    _hoisted_115,
                    _hoisted_116
                  ], 8, ["disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_117,
          _createVNode("div", _hoisted_118, [
            _hoisted_119,
            _createVNode("div", _hoisted_120, [
              _hoisted_121,
              (!_ctx.selectedUser.isSuspended)
                ? (_openBlock(), _createBlock("span", _hoisted_122, " Active "))
                : (_openBlock(), _createBlock("span", _hoisted_123, "Baned")),
              _withDirectives(_createVNode("button", {
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openModalBanAccount && _ctx.openModalBanAccount(...args))),
                class: "btn btn-sm"
              }, [
                _hoisted_124
              ], 512), [
                [
                  _directive_tooltip,
                  'Ban account',
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode(_component_Dialog, {
                header: "Ban Account",
                visible: _ctx.banAccountModal,
                "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => (_ctx.banAccountModal = $event)),
                breakpoints: { '960px': '75vw' },
                style: { width: '50vw' }
              }, {
                footer: _withId(() => [
                  _createVNode("button", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.banAccountModal = false)),
                    class: "btn btn-danger"
                  }, " Cancel "),
                  _createVNode("button", {
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.confirmBanUser && _ctx.confirmBanUser(...args))),
                    class: "btn btn-warning"
                  }, " YES, " + _toDisplayString(_ctx.selectedUser.isSuspended ? 'UNBAN' : 'BAN'), 1)
                ]),
                default: _withId(() => [
                  (!_ctx.selectedUser.isSuspended)
                    ? _withDirectives((_openBlock(), _createBlock("textarea", {
                        key: 0,
                        placeholder: "Explain why...",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.banComments = $event)),
                        class: "form-control",
                        id: "comments",
                        rows: "3"
                      }, null, 512)), [
                        [_vModelText, _ctx.banComments]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["visible"]),
              _hoisted_125,
              _hoisted_126,
              (_ctx.selectedUser.isTwoFactorAuthenticationEnabled)
                ? (_openBlock(), _createBlock("span", _hoisted_127, " Enabled "))
                : (_openBlock(), _createBlock("span", _hoisted_128, " Disabled ")),
              _withDirectives(_createVNode("button", {
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.resetTwoFactorAuth && _ctx.resetTwoFactorAuth(...args))),
                class: "btn btn-sm"
              }, [
                _hoisted_129
              ], 512), [
                [
                  _directive_tooltip,
                  'Reset',
                  void 0,
                  { top: true }
                ]
              ]),
              _createVNode(_component_ConfirmPopup)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})